export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const MAX_LEAD_DOCUMENTS = 4;
export const DOCUMENT_ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png", "pdf", "xlsx", "csv"];
export const DOCUMENT_UPLOAD_ACCEPT = DOCUMENT_ALLOWED_EXTENSIONS.map(
  (extension) => `.${extension}`,
).join(",");

export const LEAD_STATUS_SEQUENCE = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "test_drive_scheduled", label: "Test Drive Scheduled" },
  { value: "test_drive_conducted", label: "Test Drive Conducted" },
  { value: "booked", label: "Booked" },
  { value: "delivered", label: "Delivered" },
  { value: "lost", label: "Lost" },
];

export const NAV_ITEMS = [
  { label: "Sales", icon: "bolt" },
];

export const REPORT_TABS = [
  "Funnel",
  "City Wise",
  "Agent Wise",
  "Region Wise",
  "Status Wise",
  "Source Wise",
];

export const PERIOD_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "this_month", label: "This Month" },
  { value: "last_30_days", label: "Last 30 Days" },
  { value: "last_7_days", label: "Last 7 Days" },
  { value: "all_time", label: "All Time" },
];

export const INITIAL_LEAD_FORM = {
  fullName: "",
  phoneNumber: "",
  whatsappSameAsMobile: true,
  whatsappNumber: "",
  email: "",
  subSource: "",
  profession: "",
  sourceId: "",
  assignedToId: "",
  regionName: "",
  cityName: "",
  pincode: "",
  notes: "",
  dispositionId: "",
  subDispositionId: "",
  nextFollowUp: "",
};

export const INITIAL_CALL_FORM = {
  agentId: "",
  callLogId: "",
  status: "completed",
  dispositionId: "",
  subDispositionId: "",
  nextFollowUp: "",
  callQualityLevel: "good",
  remarks: "",
};

export const INITIAL_LEAD_FILTERS = {
  page: 1,
  registeredDate: "",
  registeredDateEnd: "",
  sourceId: "",
  assignedToId: "",
  region: "",
  city: "",
  dispositionRootId: "",
  subDispositionId: "",
  status: "",
  customerStatus: "",
  followUpBucket: "",
  timeLeft: "",
  attemptedCalls: "",
  connectedCalls: "",
  ordering: "-registered_at",
  campaignType: "",
  showFranchise: false,
  showOthersDetail: false,
};

export const INITIAL_REPORT_FILTERS = {
  dateFrom: "",
  dateTo: "",
  sourceId: "",
  period: "today",
  region: "",
  assignedToId: "",
  teamId: "",
  status: "",
};

export const INITIAL_BULK_ACTION_FORM = {
  file: null,
  sourceId: "",
  importType: "bulk",
};
